// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';

/** 获取当前的用户 GET /api/currentUser */
export async function currentUser(options?: { [key: string]: any }) {
  return request<{
    data: API.CurrentUser;
  }>('/api/currentUser', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 退出登录接口 POST /api/login/outLogin */
export async function outLogin(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/login/outLogin', {
    method: 'POST',
    ...(options || {}),
  });
}

/** 登录接口 POST /api/login/account */
export async function login(body: API.LoginParams, options?: { [key: string]: any }) {
  return request<API.LoginResult>('/api/login/account', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /api/notices */
export async function getNotices(options?: { [key: string]: any }) {
  return request<API.NoticeIconList>('/api/notices', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取规则列表 GET /api/rule */
export async function rule(
  params: {
    // query
    /** 当前的页码 */
    current?: number;
    /** 页面的容量 */
    pageSize?: number;
  },
  options?: { [key: string]: any },
) {
  return request<API.RuleList>('/api/rule', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 更新规则 PUT /api/rule */
export async function updateRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'update',
      ...(options || {}),
    },
  });
}

/** 新建规则 POST /api/rule */
export async function addRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'post',
      ...(options || {}),
    },
  });
}

/** 删除规则 DELETE /api/rule */
export async function removeRule(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/rule', {
    method: 'POST',
    data: {
      method: 'delete',
      ...(options || {}),
    },
  });
}


//TODO 用户相关
// 获取用户列表
export async function getUserList(params: any) {
  return request('/api/users', { method: 'GET', params });
}

// 创建用户
export async function createUser(data: any) {
  return request('/api/users', { method: 'POST', data });
}

// 更新用户
export async function updateUser(id: number, data: any) {
  return request(`/api/users/${id}`, { method: 'PUT', data });
}

// 删除用户
export async function deleteUser(id: number) {
  return request(`/api/users/${id}`, { method: 'DELETE' });
}

// Feedback
// src/services/feedback.ts

export interface Feedback {
  id: number;
  content: string;
  contact: string;
  status: number; // 0: 待处理, 1: 已处理
  create_time: string;
  update_time: string;
}

// 获取列表
export async function getFeedbackList(params: { page: number; pageSize: number }) {
  return request('/api/feedback', { method: 'GET', params });
}

// 创建
export async function createFeedback(data: Partial<Feedback>) {
  return request('/api/feedback', { method: 'POST', data });
}

// 更新
export async function updateFeedback(id: number, data: Partial<Feedback>) {
  return request(`/api/feedback/${id}`, { method: 'PUT', data });
}

// 删除
export async function deleteFeedback(id: number) {
  return request(`/api/feedback/${id}`, { method: 'DELETE' });
}
